import { render, staticRenderFns } from "./trainList.vue?vue&type=template&id=ca1a02b6&scoped=true&"
import script from "./trainList.vue?vue&type=script&lang=js&"
export * from "./trainList.vue?vue&type=script&lang=js&"
import style0 from "./trainList.vue?vue&type=style&index=0&id=ca1a02b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a02b6",
  null
  
)

export default component.exports